<template>
  <b-modal
    id="modal-link"
    modal-class="mc-modal-link"
    :title="'Bagikan Pelacakan ' + detailData?.number"
    size="md"
    centered
    scrollable
  >
    <p class="mc-paragraph">
      {{ 'Klik tombol dibawah untuk menyalin atau melihat pelacakan kendaraan.' }}
    </p>
    <b-list-group class="mc-general__label">
      <b-list-group-item href="#" @click="copyLink">
        <i class="mc-icon fas fa-link me-1"></i>
        <span class="mc-general__label">{{ $t('global.action.copyLink') }}</span>
      </b-list-group-item>
      <b-list-group-item href="#" @click="redirect">
        <i class="mc-icon icon-outline_map me-1"></i>
        <span class="mc-general__label">{{ $t('global.action.share.viewTracking') }}</span>
      </b-list-group-item>
    </b-list-group>

    <template #modal-footer>
      <McButton
        variant="secondary"
        class="me-2"
        :text="$t('global.action.cancel')"
        @click="$bvModal.hide('modal-link')"
      />
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    detailData: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    copyLink() {
      navigator.clipboard.writeText(this.detailData.public_tracking_url)
      this.$mcToast.success('Berhasil salin tautan pelacakan kendaraan!')
      this.$bvModal.hide('modal-link')
    },
    redirect() {
      const url = this.detailData.public_tracking_url
      window.open(url, '_blank')
      this.$bvModal.hide('modal-link')
    },
  },
}
</script>
